import React from 'react';
import { t } from '../types';

interface TutorialModalProps {
  selectedTutorialKey: string | null;
  closeModal: () => void;
  currentLang: string;
}

const TutorialModal: React.FC<TutorialModalProps> = ({
  selectedTutorialKey,
  closeModal,
  currentLang
}) => {
  if (!selectedTutorialKey) return null;

  const titleKey = `tutorials.${selectedTutorialKey}.title`;
  const contentKey = `tutorials.${selectedTutorialKey}.content`;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button 
          onClick={closeModal} 
          className="pixel-button modal-close-btn"
        >
          {t('button.close', currentLang)}
        </button>

        <h3 className="modal-title">
          {t(titleKey, currentLang)}
        </h3>
        <div 
          className="modal-body"
          dangerouslySetInnerHTML={{ __html: t(contentKey, currentLang) }}
        />
      </div>
    </div>
  );
};

export default TutorialModal;
